(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.addEventListener('toggle', function (event) {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) return;

    const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
    if (!target.getAttribute('data-auto-close-details')?.includes(closingOn)) return;
    if (!target.open) return;

    const siblingDetails = [...(target.parentElement?.querySelectorAll('details[data-auto-close-details]') || [])].filter(
      (element) =>
        element !== target &&
        element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
        element.open
    );

    for (const detailsElement of siblingDetails) detailsElement.removeAttribute('open');
  }, true);
})();
